import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "px-3 pt-6"
}
const _hoisted_2 = {
  key: 1,
  class: "px-3 pt-3"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Filters = _resolveComponent("Filters")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_skeleton_loader = _resolveComponent("v-skeleton-loader")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_img = _resolveComponent("v-img")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_card_subtitle = _resolveComponent("v-card-subtitle")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, { class: "pb-0" }, {
    default: _withCtx(() => [
      _createVNode(_component_v_row, { class: "ma-0" }, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, { cols: "2" }, {
            default: _withCtx(() => [
              _createVNode(_component_Filters, { config: _ctx.config }, null, 8, ["config"])
            ]),
            _: 1
          }),
          _createVNode(_component_v_col, {
            class: "pa-0",
            cols: "10"
          }, {
            default: _withCtx(() => [
              (_ctx.loading)
                ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.itemsPerPage, (n) => {
                      return (_openBlock(), _createBlock(_component_v_row, {
                        key: n,
                        class: "mb-6"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_col, {
                            cols: "3",
                            class: "pa-0"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_skeleton_loader, {
                                class: "",
                                type: "image"
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_v_col, {
                            cols: "9",
                            class: "pa-0"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_skeleton_loader, {
                                height: "150px",
                                type: "subtitle, paragraph"
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 2
                      }, 1024))
                    }), 128))
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_2, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.data, (item, index) => {
                      return (_openBlock(), _createBlock(_component_v_card, {
                        key: index,
                        class: "mb-6"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_row, { "no-gutters": "" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_col, {
                                cols: "12",
                                md: "3"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_img, {
                                    src: item.featured_image,
                                    height: "220",
                                    class: "rounded-sm",
                                    cover: ""
                                  }, null, 8, ["src"])
                                ]),
                                _: 2
                              }, 1024),
                              _createVNode(_component_v_col, {
                                cols: "12",
                                md: "9",
                                class: "pa-4"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_row, null, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_col, null, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_card_title, null, {
                                            default: _withCtx(() => [
                                              _createTextVNode(_toDisplayString(item.title), 1)
                                            ]),
                                            _: 2
                                          }, 1024)
                                        ]),
                                        _: 2
                                      }, 1024),
                                      _createVNode(_component_v_col, { class: "text-right" }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_card_subtitle, null, {
                                            default: _withCtx(() => [
                                              _createTextVNode(_toDisplayString(_ctx.$toCurrency(item.discount_price != null ? item.discount_price : item.price)), 1)
                                            ]),
                                            _: 2
                                          }, 1024),
                                          (item.discount_price != null)
                                            ? (_openBlock(), _createBlock(_component_v_card_subtitle, {
                                                key: 0,
                                                class: "text-red text-decoration-line-through text-caption"
                                              }, {
                                                default: _withCtx(() => [
                                                  _createTextVNode(_toDisplayString(_ctx.$toCurrency(item.price)), 1)
                                                ]),
                                                _: 2
                                              }, 1024))
                                            : _createCommentVNode("", true)
                                        ]),
                                        _: 2
                                      }, 1024)
                                    ]),
                                    _: 2
                                  }, 1024),
                                  _createVNode(_component_v_card_subtitle, { class: "text-grey mt-2" }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(item.year) + " ", 1),
                                      _cache[0] || (_cache[0] = _createElementVNode("span", { class: "px-2" }, "/", -1)),
                                      _createTextVNode(" " + _toDisplayString(Number(item.mileage).toLocaleString('es-MX') + ' km') + " ", 1),
                                      _cache[1] || (_cache[1] = _createElementVNode("span", { class: "px-2" }, "/", -1)),
                                      _createTextVNode(" " + _toDisplayString(item.transmission), 1)
                                    ]),
                                    _: 2,
                                    __: [0,1]
                                  }, 1024),
                                  _createVNode(_component_v_card_subtitle, { class: "d-flex align-center text-caption mt-3" }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_icon, {
                                        size: "16",
                                        class: "mr-1",
                                        color: "grey"
                                      }, {
                                        default: _withCtx(() => _cache[2] || (_cache[2] = [
                                          _createTextVNode("mdi-map-marker")
                                        ])),
                                        _: 1,
                                        __: [2]
                                      }),
                                      _createElementVNode("span", null, _toDisplayString(item.branch?.name), 1)
                                    ]),
                                    _: 2
                                  }, 1024)
                                ]),
                                _: 2
                              }, 1024)
                            ]),
                            _: 2
                          }, 1024)
                        ]),
                        _: 2
                      }, 1024))
                    }), 128))
                  ]))
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}